import React from 'react';
import cn from 'classnames';

import { TabItemPropsType } from '../../atoms/TabItem';
import Tabs from '../../molecules/Tabs';

import BreadCrumbs from './Breadcrumbs';
import RightItem from './RightItem';

import Styles from './TopBar.module.scss';

type TopBarPropsType = {
	// rightside button items.
	rightItems?: Array<React.ReactElement<typeof RightItem>>;
	// tabs
	tabs?: Array<Omit<TabItemPropsType, 'onClick'>>;
};

const TopBar: React.FC<TopBarPropsType> = ({ rightItems, tabs }) => {
	return (
		<div className={cn('colK', 'colK12', Styles.headerContainer)}>
			<div
				className={cn(
					'rowK',
					Styles.firstRowContainer,
					tabs?.length && Styles.tabContainer
				)}
			>
				<BreadCrumbs />
				<div className={cn('rowK')}>{rightItems}</div>
			</div>
			{Boolean(tabs?.length) && <Tabs items={tabs || []} />}
		</div>
	);
};

export default TopBar;
